import { useMutation } from '@tanstack/react-query';
import useToast from '../useToast';
import { postOrganizationSelection } from '@/services/api/requests/super-admin';
import { TCustomAxiosError } from '@/services/api';

const useSelectOrganizationContext = () => {
  const toast = useToast();

  const { isPending, mutate, error } = useMutation({
    mutationFn: async ({ organizationId }: { organizationId: string }) => {
      await postOrganizationSelection(organizationId);
    },
    onSuccess: () => {
      // Logic to handle successful selection, e.g., showing a success message
      toast({
        title: 'Organization Selected',
        description: 'You have successfully selected the organization. Reload the page to see changes.',
        status: 'success',
      });

      setTimeout(() => {
        window.location.reload();
      }, 2000); // Optional: Delay to allow the toast to be seen before reloading
    },
    onError: (error: TCustomAxiosError) => {
      // Logic to handle errors, e.g., showing an error message
      toast({
        title: 'Error Selecting Organization',
        description: error.errors?.[0]?.message || 'An unexpected error occurred.',
        status: 'error',
      });
    },
  });

  return {
    isPending,
    mutate,
    error,
  };
};

export default useSelectOrganizationContext;
